// extracted by mini-css-extract-plugin
export default {"container":"Confirmation__container___3cDao","block":"Confirmation__block___2clPW","actions":"Confirmation__actions___1GhB0"};